/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import BaseCommand from './BaseCommand';

/**
 * The CollaborativeCommand model module.
 * @module model/CollaborativeCommand
 * @version 1.1.0
 */
class CollaborativeCommand {
    /**
     * Constructs a new <code>CollaborativeCommand</code>.
     * Command issued by a Fire Controller for collaborative fire defense coordination
     * @alias module:model/CollaborativeCommand
     * @implements module:model/BaseCommand
     */
    constructor(state, fireControllerId, validityDuration) {
        BaseCommand.initialize(this);
        CollaborativeCommand.initialize(this, state, fireControllerId, validityDuration);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, state, fireControllerId, validityDuration) {
        obj['state'] = state;
        obj['fireControllerId'] = fireControllerId;
        obj['validityDuration'] = validityDuration;
    }

    /**
     * Constructs a <code>CollaborativeCommand</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CollaborativeCommand} obj Optional instance to populate.
     * @return {module:model/CollaborativeCommand} The populated <code>CollaborativeCommand</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CollaborativeCommand();
            BaseCommand.constructFromObject(data, obj);

            if (data.hasOwnProperty('state')) {
                obj['state'] = ApiClient.convertToType(data['state'], 'String');
            }
            if (data.hasOwnProperty('fireControllerId')) {
                obj['fireControllerId'] = ApiClient.convertToType(data['fireControllerId'], 'String');
            }
            if (data.hasOwnProperty('validityDuration')) {
                obj['validityDuration'] = ApiClient.convertToType(data['validityDuration'], 'String');
            }
            if (data.hasOwnProperty('duration')) {
                obj['duration'] = ApiClient.convertToType(data['duration'], 'String');
            }
            if (data.hasOwnProperty('timeCommanded')) {
                obj['timeCommanded'] = ApiClient.convertToType(data['timeCommanded'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CollaborativeCommand</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CollaborativeCommand</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CollaborativeCommand.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['state'] && !(typeof data['state'] === 'string' || data['state'] instanceof String)) {
            throw new Error("Expected the field `state` to be a primitive type in the JSON string but got " + data['state']);
        }
        // ensure the json data is a string
        if (data['fireControllerId'] && !(typeof data['fireControllerId'] === 'string' || data['fireControllerId'] instanceof String)) {
            throw new Error("Expected the field `fireControllerId` to be a primitive type in the JSON string but got " + data['fireControllerId']);
        }
        // ensure the json data is a string
        if (data['validityDuration'] && !(typeof data['validityDuration'] === 'string' || data['validityDuration'] instanceof String)) {
            throw new Error("Expected the field `validityDuration` to be a primitive type in the JSON string but got " + data['validityDuration']);
        }
        // ensure the json data is a string
        if (data['duration'] && !(typeof data['duration'] === 'string' || data['duration'] instanceof String)) {
            throw new Error("Expected the field `duration` to be a primitive type in the JSON string but got " + data['duration']);
        }

        return true;
    }


}

CollaborativeCommand.RequiredProperties = ["state", "fireControllerId", "validityDuration"];

/**
 * The collaborative command state
 * @member {module:model/CollaborativeCommand.StateEnum} state
 */
CollaborativeCommand.prototype['state'] = undefined;

/**
 * ID of the source Fire Controller issuing the collaborative command
 * @member {String} fireControllerId
 */
CollaborativeCommand.prototype['fireControllerId'] = undefined;

/**
 * How long this command stays valid once received, in ISO-8601 format. Not used by the deactivate command (COLLAB_NOT_ACTIVE); any value may be set in that case.
 * @member {String} validityDuration
 */
CollaborativeCommand.prototype['validityDuration'] = undefined;

/**
 * Duration in ISO-8601 format
 * @member {String} duration
 */
CollaborativeCommand.prototype['duration'] = undefined;

/**
 * The time which the command was made
 * @member {Date} timeCommanded
 */
CollaborativeCommand.prototype['timeCommanded'] = undefined;


// Implement BaseCommand interface:
/**
 * Duration in ISO-8601 format
 * @member {String} duration
 */
BaseCommand.prototype['duration'] = undefined;
/**
 * The time which the command was made
 * @member {Date} timeCommanded
 */
BaseCommand.prototype['timeCommanded'] = undefined;



/**
 * Allowed values for the <code>state</code> property.
 * @enum {String}
 * @readonly
 */
CollaborativeCommand['StateEnum'] = {

    /**
     * value: "COLLAB_ACTIVE"
     * @const
     */
    "COLLAB_ACTIVE": "COLLAB_ACTIVE",

    /**
     * value: "COLLAB_NOT_ACTIVE"
     * @const
     */
    "COLLAB_NOT_ACTIVE": "COLLAB_NOT_ACTIVE"
};



export default CollaborativeCommand;

